import ShippingTelEndBox from './shippingTelEndBox';

export default ShippingTelEndBox;